import * as Sentry from "@sentry/react";

const TRANSIENT_STREAM_ERROR_CODES = new Set([
  "ECONNABORTED",
  "ERR_CANCELED",
  "ERR_NETWORK",
  "ETIMEDOUT",
]);

type StreamChatError = {
  code?: unknown;
  isWSFailure?: unknown;
  message?: unknown;
  name?: unknown;
};

export function isTransientStreamChatError(error: unknown) {
  if (!error || typeof error !== "object") {
    return false;
  }

  const streamError = error as StreamChatError;
  const { code, message, name } = streamError;

  return (
    (typeof code === "string" && TRANSIENT_STREAM_ERROR_CODES.has(code))
    || (name === "AxiosError" && typeof message === "string" && message.includes("timeout"))
    || isStreamWebSocketFailure(streamError)
  );
}

function isStreamWebSocketFailure(error: StreamChatError) {
  if (typeof error.isWSFailure === "boolean") {
    return error.isWSFailure;
  }

  if (typeof error.message !== "string") {
    return false;
  }

  try {
    const parsedMessage: unknown = JSON.parse(error.message);

    return (
      typeof parsedMessage === "object"
      && parsedMessage !== null
      && "isWSFailure" in parsedMessage
      && parsedMessage.isWSFailure === true
    );
  }
  catch {
    return false;
  }
}

export function reportStreamChatError(error: unknown, operation: string) {
  if (isTransientStreamChatError(error)) {
    Sentry.addBreadcrumb({
      category: "stream-chat",
      level: "warning",
      message: `Temporary Stream Chat failure during ${operation}`,
    });
    return;
  }

  Sentry.captureException(error, {
    tags: {
      "stream-chat.operation": operation,
    },
  });
}
